export default defineNuxtRouteMiddleware(async (to) => {
  const resourceType = to.meta.resourceType;
  const id = to.params.id as string;

  if (!resourceType) return;

  switch (resourceType) {
    case 'organization':
      if (!id) return;
      if (await denies(manageOrganizations, id)) {
        throw createError({
          statusMessage:
            'The organization does not exist or you do not have access to it.',
          statusCode: 404,
        });
      }
      break;
    case 'invoice':
      if (await denies(manageInvoices)) {
        throw createError({
          statusMessage: 'You do not have access to this page.',
          statusCode: 404,
        });
      }
      break;
  }
});
